module.exports = __webpack_public_path__ + "0d497eaa6d90c9cde72c584777313824.png";